import { AutopilotAffectedResource } from './types';

export const AUTOPILOT_PROJECT_DATA_CHANGED = 'scrubplan:autopilot-project-data-changed';

export interface AutopilotProjectDataChangedDetail {
	actionId: number | string;
	actionType: string;
	bidPackageId?: number | null;
	changeLogItemId?: number | null;
	projectId?: number | null;
	resources?: Array<AutopilotAffectedResource | string>;
	executionStatus?: string | null;
}

const normalizedResourceType = (resource: AutopilotAffectedResource | string): string =>
	String(typeof resource === 'string' ? resource : resource.type || '')
		.trim()
		.toUpperCase()
		.replace(/[^A-Z0-9]+/g, '_')
		.replace(/^_+|_+$/g, '');

export const autopilotProjectDataChangeAffects = (
	detail: AutopilotProjectDataChangedDetail | null | undefined,
	projectId: number,
	resourceTypes: string[],
	bidPackageId?: number,
): boolean => {
	if (!detail || Number(detail.projectId) !== Number(projectId)) return false;
	const expectedTypes = resourceTypes.map((type) => normalizedResourceType(type));
	return (detail.resources || []).some((resource) => {
		const resourcePackageId =
			typeof resource === 'string'
				? detail.bidPackageId
				: resource.bidPackageId || detail.bidPackageId;
		if (bidPackageId && resourcePackageId && Number(resourcePackageId) !== Number(bidPackageId)) {
			return false;
		}
		const actualTypes = [
			normalizedResourceType(resource),
			typeof resource === 'string' ? '' : normalizedResourceType(resource.refreshHint || ''),
		].filter(Boolean);
		return expectedTypes.some((expectedType) =>
			actualTypes.some(
				(actualType) =>
					actualType === expectedType ||
					actualType.indexOf(`${expectedType}_`) === 0 ||
					expectedType.indexOf(`${actualType}_`) === 0,
			),
		);
	});
};

export const emitAutopilotProjectDataChanged = (detail: AutopilotProjectDataChangedDetail) => {
	if (typeof window === 'undefined') return;
	window.dispatchEvent(
		new CustomEvent<AutopilotProjectDataChangedDetail>(AUTOPILOT_PROJECT_DATA_CHANGED, {
			detail,
		}),
	);
};
